import React from 'react';
import styled from 'styled-components';
import {useTranslations} from "use-intl";

import {Option} from '@tager/web-core';

import Radio from '@/components/Radio';
import {FilterTypes} from '@/typings/filter/types';

import {Props} from './types';


const TrueFalse = ({field, value, onChange}: Props) => {
  const t = useTranslations();

  const handleChange = (option: Option) => {
    onChange({
      id: field.id,
      type: FilterTypes.TrueFalse,
      value:
        option.label === t('dimensions.yes')
          ? true
          : option.label === t('dimensions.false')
            ? false
            : null,
    });
  };

  const filteredFields = [
    {label: t('dimensions.yes'), value: 'true'},
    {label: t('dimensions.false'), value: 'false'},
    {label: t('dimensions.not_important'), value: 'null'},
  ];
  return (
    <Component>
      {filteredFields.map((option) => {
        return (
          <OptionComponent>
            <Radio
              checked={String(value) === option.value}
              onChange={() => handleChange(option)}
              value={option.value}
            />
            <Label>{option.label}</Label>
          </OptionComponent>
        );
      })}
    </Component>
  );
};

export default TrueFalse;

const Component = styled.div`
  position: relative;
`;

const OptionComponent = styled.label`
  cursor: pointer;
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 1rem;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }
`;

const Label = styled.span``;
